import React from "react";

//Helper to download data in statistic tables
export function CreateCSVFile(studentData, assignmentNum, quizPage, totalHintsUsed){
    let CSVJson = [];
    for(let i = 0; i < studentData.length; i++) {

        //quiz page has different output for CSV file
        if(quizPage){
            let CSVObj = {
                "Email": studentData[i].email,
                "Hints_Used": totalHintsUsed[i],
                "Date_Completed": studentData[i].date[assignmentNum]
            };
            CSVJson.push(CSVObj)

            //recording assignments have the same format
        } else {
            let CSVObj = {
                "Email": studentData[i].email,
                "Date_Completed": studentData[i].date[assignmentNum]
            };
            CSVJson.push(CSVObj)
        }

    }
    return CSVJson;
}
